
$(document).ready(function () {
  var lang = document.documentElement.dir;
  var messages = {
      "ltr": {
          messageText: "This website uses cookies to ensure you get the best experience on our website",
          linkText: "Learn more",
          linkUrl: "/privacy-policy/",
          buttonText: "Got it"
      },
      "rtl": {
          messageText: "يستخدم هذا الموقع ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة على موقعنا",
          linkText: "أعرف أكثر",
          linkUrl: "/privacy-policy/",
          buttonText: "حسناً"
      }
  };
  var selectedLang = messages[lang] ? lang : "ltr";
  $.cookit({
      messageText: messages[selectedLang].messageText,
      linkText: messages[selectedLang].linkText,
      linkUrl: messages[selectedLang].linkUrl,
      buttonText: messages[selectedLang].buttonText
  });
});

// $.cookit({
//   messageText: "This website uses cookies to ensure you get the best experience on our website",
//   linkText: "Learn more",
//   linkUrl: "/privacy-policy/",
//   buttonText: "Got it"
// });
